import Relay from 'react-relay/classic';

import CourseDetails from './CourseDetails';
import LearnerCard from '../learnerCard';
import SectionCell from './SectionCell';

const rootQuery = variables => Relay.QL`
  fragment on Course {
    id
    pid
    name
    totalCards
    cardLockData
    deactivateFrom
    orderOfCompletion
    certificateEnabled
    badge
    contributeToSuccessStatus
    ${CourseDetails.getFragment('rootQ')}
    prerequisites {
      course {
        pid
        coursePerformance(userId: $userId) {
          completionStatus
        }
      }
      unlockCriteria
    }
    coursePerformance {
      id
      visibleCompleted
      timeSpent
      scaledProgressMeasure
      completionStatus
      successStatus
      state
    }
    assignInfo{
      id
      dueDate
      assignedBy{
        pid
      }
    }
    teachers{
      pid
      name
      picture
    }
    user(id: $userId) {
      id
      pid
    }
    sections(first: 200) {
      edges {
        node {
          pid
          cards(first: 200) {
            edges {
              node {
                id
                pid
                name
                rawData
                type
                duration
                isGradable
                completionType
                questionsForReview {
                  currentReviewCount
                }
                questionAnswers(userId: $userId) {
                  q
                  gradingScheme
                }
                resource{
                  type
                }
                globalPosition
                minReviewCount
                performance(userId: $userId) {
                  id
                  completionStatus
                  successStatus
                  timeSpent
                }
                ${LearnerCard.getFragment('rootQ', { userId: variables.userId })}
              }
            }
          }
          ${SectionCell.getFragment('rootQ', { userId: variables.userId })}
        }
      }
    }
  }
`;

export default rootQuery;
